import apiClient from './apiClient'
import { getIdOrNull } from '..'

export const getSchoolPeriods = (user, queryParams = {}) => apiClient.get(user, 'api/school-periods', queryParams)

/** @param {SchoolPeriod} schoolPeriod */
export const createSchoolPeriod = (user, schoolPeriod) => apiClient.post(user, 'api/school-periods', schoolPeriod.toRequestBody())

/** @param {SchoolPeriod} schoolPeriod */
export const updateSchoolPeriod = (user, schoolPeriod) => apiClient.patch(user, `api/school-periods/${getIdOrNull(schoolPeriod)}`, schoolPeriod.toRequestBody())

/** @param {SchoolPeriod | number} schoolPeriod */
export const deleteSchoolPeriod = (user, schoolPeriod) => apiClient.delete(user, `api/school-periods/${getIdOrNull(schoolPeriod)}`)
